import { Card, Form } from 'ui';
import { JoinedCommunitiesListContent } from './joined-communities-list-content';
import {
  JoinedCommunitiesListFilters,
  type JoinedCommunitiesListFiltersFormValues,
} from './joined-communities-list-filters';

type FormValues = JoinedCommunitiesListFiltersFormValues;

type P = {
  getPathToCommunityDetail: (id: string) => string;
};

const JoinedCommunitiesList = ({ getPathToCommunityDetail }: P) => (
  <Card>
    <Form<FormValues> noOptional>
      <JoinedCommunitiesListFilters />
      <Form.Item<FormValues> dependencies={['search']} noStyle>
        {({ getFieldsValue }) => {
          const { search } = getFieldsValue();

          return <JoinedCommunitiesListContent getPathToCommunityDetail={getPathToCommunityDetail} search={search} />;
        }}
      </Form.Item>
    </Form>
  </Card>
);

export default JoinedCommunitiesList;
